























import { Vue, Component } from "vue-property-decorator";
import CustomImage from '@/components/Globals/CustomImage.vue';
import CustomText from "@/components/Globals/CustomText.vue";
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import randomize from "@/mixins/Customizer/Randomize";
@Component({
  components: {
    CustomImage,
    CustomText,
    CustomButton,
    CustomContainer
  },
  mixins: [randomize],
})
export default class TabRandomize extends Vue {
  get isRandomizeEnabled() {
    const { pdm, configuration } = this.$store.state.utils;
    return pdm && !configuration.randomize?.turn_off_all_models &&
      configuration.randomize?.models_enabled.includes(pdm.sku);
  }

  get customsAssets() {
    return this.$store.state.endPoints.customizer.customsAssets;
  }

  get isApparel() {
    return this.$store.getters['utils/isApparelEnabled'];
  }

  get translations() {
    return this.$store.state.translations.data;
  }
}
